import React from 'react';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import Select from './Select';

function EffectiveDate() {
  const { effective_date: effectiveDate } = useSelector(store => store.values);
  const { additionalEffectiveDate: aed = {} } = useSelector(store => store.theme);

  const opt1 = DateTime.now().startOf('month').plus({ month: 1 });
  const opt2 = DateTime.now().startOf('month').plus({ month: 2 });
  const opt3 = DateTime.now().startOf('month').plus({ month: 3 });

  const options = [
    { label: opt1.toFormat('MMMM y'), value: opt1.toISODate() },
    { label: opt2.toFormat('MMMM y'), value: opt2.toISODate() },
    { label: opt3.toFormat('MMMM y'), value: opt3.toISODate() },
  ];

  if (aed.val && !options.some(e => (e.value === aed.val))) {
    options.splice(0, 0, { label: aed.desc, value: aed.val });
  }

  if (!options.some(e => (e.value === effectiveDate))) {
    const customED = DateTime.fromISO(effectiveDate);
    options.push({ label: customED.toFormat('MMMM y'), value: customED.toISODate(), disabled: true });
  }

  return (
    <div>
      <Select
        cols="6"
        label="Effective Date"
        name="effective_date"
        customOptions={options}
      />
    </div>
  );
}

export default EffectiveDate;
